import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {IncorporationComponent} from './incorporation.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [IncorporationComponent],
  exports: [IncorporationComponent]
})
export class IncorporationModule {
}



// WEBPACK FOOTER //
// ./src/app/components/incorporation/incorporation.module.ts